const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	lista: [],
	listaUnidade: [],
	listaUsuario: [],
	listaTipo: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'USUARIO_ACESSORIO_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

        case 'USUARIO_ACESSORIO_LISTADO':
            return {
				...state,
				lista: action.payload.data
			};

		case 'USUARIO_ACESSORIO_UNIDADE_SELECT_LISTADO':
			return {
				...state,
				listaUnidade: action.payload.data
			};

		case 'USUARIO_ACESSORIO_USUARIO_SELECT_LISTADO':
			return {
				...state,
				listaUsuario: action.payload.data
			};

		case 'USUARIO_ACESSORIO_TIPO_SELECT_LISTADO':
			return {
				...state,
				listaTipo: action.payload.data
			};

        default:
            return state;
    }
}
